import { keepPreviousData, useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { assignToUsersQueryKeys } from "../key-factory/factory";

export const useAssignableUsersQuery = () => {
    return useQuery({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: assignToUsersQueryKeys.assignableUsersList(),
        placeholderData: keepPreviousData,
        queryFn({ signal }) {
            return salesApiService.assignToUsers.fetchAssignableUsers({ cancellation: signal });
        },
    });
};
